/**
 * 1. Visibilidad del menu y submenu
 *
 * Cuando el elemento #recursos-c-1 sea visible en un 20% de la pantalla, hace el menu y submenu mas oscuro
 */
function onScrollChangeThemeMenuAndSubmenu(recurso_class) {

    console.log('run onScrollChangeThemeMenuAndSubmenu');

    let menu = document.getElementById('menu')
    let subMenus = document.querySelectorAll('.sub-menu')
    let recursos = document.querySelector(recurso_class)

    function setDarkMenuAndSubmenu() {
        menu.classList.remove('navbar-transparent')
        subMenus.forEach(subMenu => {
            subMenu.classList.remove('navbar-transparent')
        })
    }

    function setTransparentMenuAndSubmenu() {
        menu.classList.add('navbar-transparent')
        subMenus.forEach(subMenu => {
            subMenu.classList.add('navbar-transparent')
        })
    }

    const onIntersection = (entries) => {
        entries.forEach(entry => {

            let noOscurecerMenu = entry.isIntersecting;

            if (noOscurecerMenu) {
                setTransparentMenuAndSubmenu()
            }else{
                setDarkMenuAndSubmenu()
            }
        })
    }

    const options = { threshold: [0.2] }

    const observer = new IntersectionObserver(onIntersection, options)

    if (recursos) {
        observer.observe(recursos)
    }
}

/**
 * 2. Notificaciones
 */
function showGlobalNotification() {}

/**
 *
 * 2.1. Determina si el usuario tiene conexión a internet
 *
 * @param {Boolean} showToast
 * @returns {online: Boolean, literal: String}
 */
function currentOnlineStatus(showToast = true) {
    let status = {
        online: window.navigator.onLine,
        literal: window.navigator.onLine ? 'online' : 'offline'
    }
    if (showToast) {
        showNotification({
            message: `Conexión a internet: ${status.literal}`,
            type: status.online ? 'success' : 'info',
        });
    }
    return status;
}

/**
 * 2.2 Añade un evento para detectar si el usuario tiene conexión a internet
 */
function addEventListenerOnline() {
    window.addEventListener('online', () => {
        console.log('online');
        showNotification({
            message: 'Conexión a internet establecida',
            type: 'success',
        });
        // worker.postMessage({ online: true });
    });
}

/**
 * 2.3 Añade un evento para detectar si el usuario no tiene conexión a internet
 */
function addEventListenerOffline() {
    window.addEventListener('offline', () => {
        console.log('offline');
        showNotification({
            message: 'Conexión a internet perdida',
            type: 'info',
        });
        // worker.postMessage({ online: false });
    });
}

/**
 * 2.4 Muestra una notificación
 *
 * @param {type: string, message: string} data
 */
function showNotification(data) {

    let typeMsg = {
        success: 'linear-gradient(90deg, #289543 0%, #289543 80%, #B6C62F 100%)',
        error: 'linear-gradient(90deg, #951010 0%, #951010 80%, #C64F2F 100%)',
        warning: 'linear-gradient(90deg, #FF0000 0%, #FF0000 80%, #FF0000 100%)',
        info: 'linear-gradient(90deg, #FF0000 0%, #FF0000 80%, #FF0000 100%)'
    };

    let bgStyleType = typeMsg[data.type];
    Toastify({
        text: data.message,
        duration: 5000,
        gravity: "bottom",
        position: "right",
        stopOnFocus: true,
        style: {
            background: bgStyleType,
        },
    }).showToast();
}

/**
 * 2.5 Boton para sincronizar la página
 */
function onClickSync(btnId, callbackOnline = null, callbackOffline = null) {
    let elBtnSync = document.getElementById(btnId);
    if(!elBtnSync) return;

    elBtnSync.addEventListener('click', function(event) {
        event.preventDefault();
        let statusCon = currentOnlineStatus(false);

        if(elBtnSync.hasAttribute('disabled')) {
            showNotification({
                message: 'Ya se está sincronizando',
                type: 'info',
            });
            return;
        }else{
            elBtnSync.setAttribute('disabled', 'disabled');
            elBtnSync.classList.add('opacity-25', 'cursor-not-allowed');
        }

        if(statusCon.online) {
            let currentUrl = window.location.href;
            cachePageDynamically(currentUrl);
            if(callbackOnline) {
                callbackOnline();
            }
            showNotification({
                message: 'Sincronización exitosa',
                type: 'success',
            });
        } else {
            if(callbackOffline) {
                callbackOffline();
            }
            showNotification({
                message: 'No se puede sincronizar en modo offline',
                type: 'warning',
            });
        }
    });
}

/**
 * 2.6 Método para cachear una página dinámica
 *
 * ej. window.cachePageDynamically('http://localhost:8008/profile/service-sat/18/user-sign');
 *
 * @param {string} url
 */
function cachePageDynamically(url, isAjaxRequest = false) {
    if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
        navigator.serviceWorker.controller.postMessage({
            type: 'CACHE_URL',
            url: url,
            isAjaxRequest: isAjaxRequest,
        });
        console.log(`Página enviada al Service Worker para cachear: ${url}`);
    } else {
        console.warn('Service Worker no está activo o soportado.');
    }
}

document.addEventListener('DOMContentLoaded', () => {
    onScrollChangeThemeMenuAndSubmenu("#recursos-c-1")
    onScrollChangeThemeMenuAndSubmenu(".recursos-first-element")

    // Estado de la conexión a internet
    addEventListenerOnline()
    addEventListenerOffline()
})

/**
 * 3. Método para crear un modal a partir de una imagen.
 *
 * @param {string} mainClass Selector principal del contenedor de las imágenes
 */
function createModalImage(mainClass = ".alignImg") {
    // Crear el modal
    let modal = document.createElement("div");
    modal.style.position = "fixed";
    modal.style.top = "0";
    modal.style.left = "0";
    modal.style.width = "100%";
    modal.style.height = "100%";
    modal.style.backgroundColor = "rgba(0, 0, 0, 0.8)";
    modal.style.display = "none";
    modal.style.justifyContent = "center";
    modal.style.alignItems = "center";
    modal.style.zIndex = "1999";
    modal.style.opacity = "0";
    modal.style.transition = "opacity 0.3s ease";

    // Crear la imagen dentro del modal
    let modalImg = document.createElement("img");
    modalImg.style.maxWidth = "90%";
    modalImg.style.maxHeight = "90%";
    modalImg.style.borderRadius = "1.5em";
    modal.style.cursor = "pointer";

    modal.appendChild(modalImg);
    document.body.appendChild(modal);

    // Evento para abrir el modal
    let listImages = document.querySelectorAll(`${mainClass} img`);
    listImages.forEach(img => {
        img.style.cursor = "pointer";
        img.addEventListener("click", function () {
            modalImg.src = this.src;
            modal.style.display = "flex";
            setTimeout(() => { modal.style.opacity = "1"; }, 10);
        });
    });

    // Evento para cerrar el modal
    modal.addEventListener("click", function () {
        modal.style.opacity = "0";
        setTimeout(() => { modal.style.display = "none"; }, 300);
    });
}

/**
 * 3.1. Método para inicializar el modal de las imágenes
 */
function initModalImage() {
    document.addEventListener("DOMContentLoaded", () => {
        createModalImage(".use-modal-image");
        createModalImage(".use-modal-image-on-align-img .alignImg");
    });
}
initModalImage();

/**
 * Shop/Ecommerce functions
 */
function displayPrice(value, currencySymbol = '€', locale = 'es-ES') {
    if (isNaN(value)) return '';

    const formatter = new Intl.NumberFormat(locale, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });

    return `${formatter.format(value)} ${currencySymbol}`;
}


/**
 * Export functions to window
 */
window.showNotification = showNotification;
window.currentOnlineStatus = currentOnlineStatus;
window.onClickSync = onClickSync;
window.cachePageDynamically = cachePageDynamically;
window.createModalImage = createModalImage;
window.displayPrice = displayPrice;
